module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/22c4291ba7654bf25a16d92e827d0a43.gif";